import { useState, useEffect, useRef } from "react";
import styles from "./CommonNavBar.module.less";

function CommonNavBar({
  title,
  titleColor,
  backgroundColor,
  isTop = false,
  noSafe = false,
  showLeft = true,
  leftContent = null,
  onClickBack = () => {},
  rightContent = null,
  hideOnScroll = false,
  threshold = 100,
  scrollContainer = null, // 新增：可以传入滚动容器的选择器或ref
}) {
  const [isVisible, setIsVisible] = useState(true);
  const [lastScrollTop, setLastScrollTop] = useState(0);
  const scrollElementRef = useRef(null);

  useEffect(() => {
    if (!hideOnScroll) return;

    // 获取滚动容器
    const getScrollElement = () => {
      if (!scrollContainer) return window;

      if (typeof scrollContainer === "string") {
        // 如果是选择器字符串
        return document.querySelector(scrollContainer) || window;
      } else if (scrollContainer.current) {
        // 如果是 React ref
        return scrollContainer.current;
      } else if (scrollContainer instanceof HTMLElement) {
        // 如果是 DOM 元素
        return scrollContainer;
      }
      return window;
    };

    scrollElementRef.current = getScrollElement();
    const handleScroll = () => {
      const element = scrollElementRef.current;
      const currentScrollTop =
        element === window ? window.pageYOffset : element.scrollTop;

      const scrollDelta = currentScrollTop - lastScrollTop;

      if (scrollDelta > 0 && currentScrollTop > threshold) {
        setIsVisible(false);
      } else if (scrollDelta < 0 || currentScrollTop <= threshold) {
        setIsVisible(true);
      }

      setLastScrollTop(currentScrollTop);
    };

    const scrollTarget = scrollElementRef.current;
    scrollTarget.addEventListener("scroll", handleScroll, { passive: true });

    return () => {
      scrollTarget.removeEventListener("scroll", handleScroll);
    };
  }, [hideOnScroll, lastScrollTop, threshold, scrollContainer]);

  return (
    <div
      className={`${styles["common-bar"]} ${
        noSafe ? styles["common-bar--no-safe"] : ""
      } ${!isVisible ? styles["common-bar--hidden"] : ""}`}
    >
      {!isTop ? <div className={styles["placeholder-block"]}></div> : null}
      <div
        className={`${styles["bar-wrapper"]}`}
        style={{ background: backgroundColor || "" }}
      >
        <div className={styles["bar-wrapper-content"]}>
          {showLeft ? (
            leftContent ? (
              leftContent
            ) : (
              <img
                className={styles["content-icon"]}
                onClick={onClickBack}
                src={require("@/images/login/ic_back.png")}
                alt="back"
              />
            )
          ) : null}
          <div
            className={styles["content-title"]}
            style={{ color: titleColor || "" }}
          >
            {title}
          </div>
          {rightContent || null}
        </div>
      </div>
    </div>
  );
}

export default CommonNavBar;
